module.exports = __webpack_public_path__ + "static/media/ta-05.5ac159ab.png";